import React, { useEffect, useRef } from 'react';
import style from '../JumioPopupUploader.scss';

export const ProgressBar = ({ verificationTimeout }) => {
    const fillBarRef = useRef(null);

    useEffect(() => {
        if (fillBarRef.current) {
            setTimeout(() => {
                fillBarRef.current.style.width = '100%';
            }, 0);
        }
    }, [fillBarRef]);

    return (
        <div className={style.progressbar__container}>
            <div className={style.progressbar}>
                <div className={style.fillbar} ref={fillBarRef} style={{ transition: `width ${verificationTimeout}ms cubic-bezier(0.45, 0.05, 0.55, 0.95)` }} />
            </div>
        </div>
    );
};
